/**
 * S3 Upload URL Response
 */
export class S3UploadURLResponseDTO {
  /**
   * @constructor
   */
  constructor(
    public readonly uploadUrl: string,
    public readonly newFileName: string,
    public requestId?: number
  ) {}
}
